export const rashiValues = [
    'Mesh (Aries)', 'Vrishabh (Taurus)', 'Mithuna (Gemini)', 'Karka (Cancer)', 'Simha (Leo)', 'Kanya (Virgo)',
    'Tula (Libra)', 'Vrischika (Scorpion)', 'Dhanur (Sagittarious)', 'Makara (Capricorn)', 'Kumbha (Aquarius)', 'Meena (Pisces)'
];

export const complexionValues = [
    'Very Fair', 'Fair', 'Medium', 'Brown', 'Dark'
];

export const heightValues = [
    '3 feet 6 inches', '3 feet 7 inches', '3 feet 8 inches',
    '3 feet 9 inches', '3 feet 10 inches', '3 feet 11 inches',
    '4 feet 0 inches', '4 feet 1 inches', '4 feet 2 inches',
    '4 feet 3 inches', '4 feet 4 inches', '4 feet 5 inches',
    '4 feet 6 inches', '4 feet 7 inches', '4 feet 8 inches',
    '4 feet 9 inches', '4 feet 10 inches', '4 feet 11 inches',
    '5 feet 0 inches', '5 feet 1 inches', '5 feet 2 inches',
    '5 feet 3 inches', '5 feet 4 inches', '5 feet 5 inches',
    '5 feet 6 inches', '5 feet 7 inches', '5 feet 8 inches',
    '5 feet 9 inches', '5 feet 10 inches', '5 feet 11 inches',
    '6 feet 0 inches', '6 feet 1 inches', '6 feet 2 inches',
    '6 feet 3 inches', '6 feet 4 inches', '6 feet 5 inches',
    '6 feet 6 inches', '6 feet 7 inches', '6 feet 8 inches',
    '6 feet 9 inches', '6 feet 10 inches', '6 feet 11 inches',
    '7 feet 0 inches', '7 feet 1 inches', '7 feet 2 inches',
    '7 feet 3 inches', '7 feet 4 inches', '7 feet 5 inches',
    '7 feet 6 inches'
];

export const weightValues = [
    '40 Kg', '41 Kg', '42 Kg', '43 Kg', '44 Kg', '45 Kg',
    '46 Kg', '47 Kg', '48 Kg', '49 Kg', '50 Kg', '51 Kg',
    '52 Kg', '53 Kg', '54 Kg', '55 Kg', '56 Kg', '57 Kg',
    '58 Kg', '59 Kg', '60 Kg', '61 Kg', '62 Kg', '63 Kg',
    '64 Kg', '65 Kg', '66 Kg', '67 Kg', '68 Kg', '69 Kg',
    '70 Kg', '71 Kg', '72 Kg', '73 Kg', '74 Kg', '75 Kg',
    '76 Kg', '77 Kg', '78 Kg', '79 Kg', '80 Kg', '81 Kg',
    '82 Kg', '83 Kg', '84 Kg', '85 Kg', '86 Kg', '87 Kg',
    '88 Kg', '89 Kg', '90 Kg', '91 Kg', '92 Kg', '93 Kg',
    '94 Kg', '95 Kg', '96 Kg', '97 Kg', '98 Kg', '99 Kg',
    '100 Kg', '101 Kg', '102 Kg', '103 Kg', '104 Kg', '105 Kg',
    '106 Kg', '107 Kg', '108 Kg', '109 Kg', '110 Kg', '111 Kg',
    '112 Kg', '113 Kg', '114 Kg', '115 Kg', '116 Kg', '117 Kg',
    '118 Kg', '119 Kg', '120 Kg'
];

export const bloodGroupValues = [
    'A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'
];

export const defaultRashiIndex = 0;
export const defaultComplexionIndex = 0;
export const defaultHeightIndex = 25;
export const defaultWeightIndex = 20;
export const defaultBloodGroupIndex = 2;

export const testState = {
    headerIcon: { checked: true },
    headerText: { checked: true, value: '|| Shree Ganesh ||' },
    name: { checked: true, value: 'Krishna Mohan Sawant' },
    dob: { checked: true, value: '1994-10-14' },
    tob: { checked: true, value: '08:45' },
    pob: { checked: true, value: 'Mumbai' },
    religionCaste: { checked: true, value: 'Hindu Kunbi' },
    rashi: { checked: true, value: 2 },
    nakshatra: { checked: true, value: 'Dhanishtha' },
    complexion: { checked: true, value: defaultComplexionIndex },
    height: { checked: true, value: defaultHeightIndex },
    weight: { checked: true, value: defaultWeightIndex },
    bloodGroup: { checked: true, value: 2 },
    education: { checked: true, value: 'BE in CSE' },
    job: { checked: true, value: 'Software Developer' },
    salary: { checked: true, value: '1,00,000/month' },
    hobbies: { checked: true, value: 'Singing, Dancing' },
    father: { checked: true, value: 'Mohan Sawant' },
    fatherJob: { checked: true, value: 'BMC Officer' },
    fatherNative: { checked: true, value: 'Sawantwadi' },
    mother: { checked: true, value: 'Rohini Sawant' },
    motherJob: { checked: true, value: 'Housewife' },
    motherNative: { checked: true, value: 'Sangli' },
    brotherElder: { checked: true, value: 'Ashish Sawant' },
    brotherElderJob: { checked: true, value: 'Software Developer' },
    brotherYounger: { checked: true, value: 'Nitesh Sawant' },
    brotherYoungerJob: { checked: true, value: 'Persuing MBBS' },
    sisterElder: { checked: true, value: 'Tejal Sawant' },
    sisterElderJob: { checked: true, value: 'Dentist' },
    sisterYounger: { checked: true, value: 'Nisha Sawant' },
    sisterYoungerJob: { checked: true, value: 'Persuing CS Engg.' },
    relatives: { checked: true, value: 'Thakare, Desale, Pingale, Harad, Kor, Gharat' },
    contact: { checked: true, value: '9876543210' },
    address: { checked: true, value: 'A12, Swargarohini Apartment, Lok Chowk, Vrindavan Road, Buldana, 411011' },
    image: { checked: false, value: '' },
    filename: { checked: true, value: 'test.png' }
};
